import React, {useState, useEffect, useContext} from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";
import calc from "../../../utils/calculation";


import PrintHeader from "../common/PrintHeader";

import Img from "../../common/Img";

import SummaryCard from "./_SummaryCard";
import PaymentsList from "./_PaymentsList";
import PayableList from "./_PayableList";
import Chart from "./_Chart";
import { formatPrintMoney } from "../financePrintUtils";

const CreditorPayments = (props) => {

    const {creditor_id, activeYear} = props.match.params;


    const [data, setData] = useState([]);
    const [payables, setPayables] = useState([]);
    const [payments, setPayments] = useState([]);


    let printHeadTexts = [
        'معاونیت امور اداری و مالی',
        'مدیریت مالی'
    ];

    let title = 'گزارشات';

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);


    const requestData = async () => {
        let query = `creditors/${creditor_id}/payments`;
        await db.getAll(query).then(({ data }) => {
            setData(data);
            if(data.data){
                setPayments(data?.data[0]?.payments.filter((p) => p.half_year_id == activeYear));
                setPayables(data?.data[0]?.payables.filter((p) => p.half_year_id == activeYear));
            }
        });
    };


    return (
        <main className="main-print-wrapper">
            <PrintHeader
                title={title}
                subtitle={payables[0]?.half_year || payments[0]?.half_year}
                date={' '}
                printHeadTexts={printHeadTexts}
            />

            <div style={{display: "grid", gap: "10px"}}>
                <div className="print-finance-top-row" style={{display: "grid", gridTemplateColumns: "auto 70%", gap: "10px"}}>
                    <div className="white-background-with-border">
                        <Chart data={data && data}/>
                    </div>
                    <div className="white-background-with-border print-finance-profile-panel"
                         style={{
                             display: "grid",
                             gridTemplateColumns: "auto auto",
                             alignItems: "center",
                             justifyItems: "center",
                             padding: "20px 0"
                         }}>
                        <div className="overall-summary" style={{
                            width: "100%",
                            paddingLeft: "80px",
                        }}>
                            <div className="wrapper">
                                <p>{lbl.OverallBalance}</p>
                                <h2 className="print-ltr-amount">{formatPrintMoney(data?.summary?.overall_balance)}</h2>
                            </div>
                        </div>
                        <div className="print-finance-profile-row" style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            gap: "20px",
                            alignContent: "flex-end",
                            placeItems: "center",
                            width: "100%",
                            paddingRight: "50px",
                        }}>
                            <div className="std-profile rounded">
                                <div className="wrapper">
                                    <Img src={data?.summary?.photo}/>
                                </div>
                            </div>

                            <div>
                                <div className="wrapper" style={{textAlign: "right"}}>
                                    <h3>{data?.summary?.name}</h3>
                                    <p>{data?.summary?.phone}</p>
                                    <p>{data?.summary?.email}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="report-summary-area white-background-with-border">
                    <SummaryCard title={lbl.Summary} data={data} payables={payables} payments={payments}/>
                </div>
            </div>

            <div style={{
                marginTop: "15px"
            }}>
                <p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.Payables}</p>
                <PayableList data={payables}/>
            </div>


            <div style={{
                marginTop: "15px"
            }}>
                <p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.Payments}</p>
                <PaymentsList data={payments}/>
            </div>

            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء تایید کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء پرداخت کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء گیرنده</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default CreditorPayments;
